<template>
	<button
		type="button"
		class="ring-focus rounded px-4 py-2 text-xl transition-colors duration-150 outline-hidden hover:bg-gray-50 focus:bg-gray-50 focus:outline-2 focus:outline-white"
	>
		<slot />
	</button>
</template>
